import { render, staticRenderFns } from "./CellRendererDataAI.vue?vue&type=template&id=39483080&scoped=true"
import script from "./CellRendererDataAI.vue?vue&type=script&lang=js"
export * from "./CellRendererDataAI.vue?vue&type=script&lang=js"
import style0 from "./CellRendererDataAI.vue?vue&type=style&index=0&id=39483080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39483080",
  null
  
)

export default component.exports